import { getNodeViewDecorators } from "./../../../../ricos-common-plugins/viewer.js";
import { ANIMATION_TYPE } from "./../../../../ricos-content/index.js";
import { hasPlugin } from "./../../../../_shared/has-plugin.js";
import { AnimationDecorator } from "./animation-decorator.js";
import { BreakoutDecorator } from "./breakout-decorator.js";
import { Decorators as NodeViewDecorators } from "./node-view-decorators.js";
const getDecorators = (plugins) => [
  ...getNodeViewDecorators(plugins),
  // Without pluginAnimationViewer no runtime reveals `data-ricos-animation` nodes, so
  // don't emit the markup. The hide CSS is scoped to its own viewer instance
  // (node-animations.tsx), so this is belt-and-braces rather than the only protection.
  ...hasPlugin(ANIMATION_TYPE, plugins) ? [AnimationDecorator] : [],
  BreakoutDecorator
];
export {
  NodeViewDecorators,
  getDecorators
};
//# sourceMappingURL=index.js.map
